"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import FeedbackForm from "./FeedbackForm";

export default function FeedbackButton() {
	const [open, setOpen] = useState(false);
	const t = useTranslations("feedback");
	const tc = useTranslations("components");
	return (
		<>
			<button
				className="cgFeedbackFab"
				aria-label={t("fab")}
				onClick={() => setOpen(true)}
			>
				{t("fab")}
			</button>
			{open && (
				<div
					className="cgFeedbackModal"
					role="dialog"
					aria-modal="true"
					onClick={() => setOpen(false)}
				>
					<div
						className="cgFeedbackModalInner"
						onClick={(e) => e.stopPropagation()}
					>
						<div className="cgFeedbackHead">
							<h3>{t("title")}</h3>
							<button
								className="cgFeedbackClose"
								aria-label={tc("close")}
								onClick={() => setOpen(false)}
							>
								×
							</button>
						</div>
						<FeedbackForm compact />
					</div>
				</div>
			)}
		</>
	);
}
